import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert, Flex, Spin } from 'antd';
import { QuestionCircleOutlined } from "@ant-design/icons";
import * as cookie from "react-cookies";
import { dispatchLoginResponseV6Router, performUsernamePasswordLogin } from './PerformLogin';
import LoginForm, {} from "./LoginForm";
import PublicPageLayout from "../PublicPageLayout";
import AUTH from "../../constants/Auth";
import PassKeyLoginForm from "./PassKeyLoginForm";
import { useAppDispatch, useAppSelector } from "../../store";
import { loggedInUserSelector } from "../../store/slice/auth";
export default function LoginPage() {
    const [errorMessage, setErrorMessage] = useState(null);
    const [authenticating, setAuthenticating] = useState(false);
    const [requiresOTP, setRequiresOTP] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const dispatch = useAppDispatch();
    useEffect(() => {
        const sessionCookie = cookie.load(AUTH.userAuthCookieName, true);
        if (sessionCookie && loggedInUser) {
            let toUrl = "/";
            if (searchParams.has("toUrl")) {
                toUrl = searchParams.get("toUrl");
            }
            const shouldSetup2FA = cookie.load(AUTH.shouldSetup2FACookieName, false);
            if (shouldSetup2FA) {
                toUrl = '/multi-factor/setup';
            }
            navigate(toUrl);
        }
    }, [loggedInUser]);
    function onDoLogin(values) {
        setErrorMessage(null);
        setAuthenticating(true);
        performUsernamePasswordLogin(values.username, values.password, values.oneTimePassword, values.rememberMe, (loginResponse, errorMsg, mfaRequired) => {
            setAuthenticating(false);
            setErrorMessage(errorMsg);
            if (mfaRequired) { // Only set the positive case, we set OTP required to false if the username field is modified
                setRequiresOTP(mfaRequired);
            }
            if (loginResponse && !mfaRequired) {
                dispatchLoginResponseV6Router(loginResponse, navigate, searchParams.get("toUrl"), dispatch);
            }
        });
    }
    return (_jsx(PublicPageLayout, { heading: "Login", footer: _jsxs("a", { href: "#/forgot-password", children: [_jsx(QuestionCircleOutlined, {}), " Forgot your password?"] }), children: _jsxs(_Fragment, { children: [errorMessage &&
                    _jsxs(_Fragment, { children: [_jsx(Alert, { title: "Login Failed", description: errorMessage, type: "error", showIcon: true }), _jsx("br", {})] }), _jsx(Spin, { spinning: authenticating, delay: 500, children: _jsxs(Flex, { vertical: true, gap: "middle", children: [_jsx(LoginForm, { onDoLogin: onDoLogin, requiresOTP: requiresOTP, onUsernameChanged: () => setRequiresOTP(false) }), _jsx(PassKeyLoginForm, { errorMessageHandler: (errorMessage) => {
                                    setErrorMessage(errorMessage);
                                } })] }) })] }) }));
}
